(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-ab-home-synced]').forEach((root) => {
      if (root.dataset.loaded === 'true') return;
      root.dataset.loaded = 'true';

      const badgesId = root.dataset.badgesId;
      const buyerId = root.dataset.buyerId;
      const brandId = root.dataset.brandId;
      const faqId = root.dataset.faqId;
      const recentId = root.dataset.recentId;
      const newsletterId = root.dataset.newsletterId;
      const sectionIds = [];
      if (root.dataset.showBadges === 'true') sectionIds.push(badgesId);
      if (root.dataset.showBuyer === 'true') sectionIds.push(buyerId);
      if (root.dataset.showBrand === 'true') sectionIds.push(brandId);
      if (root.dataset.showFaq === 'true') sectionIds.push(faqId);
      if (root.dataset.showRecent === 'true') sectionIds.push(recentId);
      if (root.dataset.showNewsletter === 'true') sectionIds.push(newsletterId);
      if (!sectionIds.length) return;

      const url = new URL('/', window.location.origin);
      url.searchParams.set('sections', sectionIds.join(','));

      fetch(url, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error('Unable to load synchronized homepage sections.');
          return response.json();
        })
        .then((sections) => {
          const badgesTarget = root.querySelector('[data-ab-home-sync-target="badges"]');
          const buyerTarget = root.querySelector('[data-ab-home-sync-target="buyer"]');
          const brandTarget = root.querySelector('[data-ab-home-sync-target="brand"]');
          const faqTarget = root.querySelector('[data-ab-home-sync-target="faq"]');
          const recentTarget = root.querySelector('[data-ab-home-sync-target="recent"]');
          const newsletterTarget = root.querySelector('[data-ab-home-sync-target="newsletter"]');
          if (badgesTarget && sections[badgesId]) badgesTarget.innerHTML = sections[badgesId];
          if (buyerTarget && sections[buyerId]) buyerTarget.innerHTML = sections[buyerId];
          if (brandTarget && sections[brandId]) brandTarget.innerHTML = sections[brandId];
          if (faqTarget && sections[faqId]) faqTarget.innerHTML = sections[faqId];
          if (recentTarget && sections[recentId]) recentTarget.innerHTML = sections[recentId];
          if (newsletterTarget && sections[newsletterId]) newsletterTarget.innerHTML = sections[newsletterId];
        })
        .catch(() => {
          root.hidden = true;
        });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
